module.exports = __webpack_public_path__ + "1d1575fe223c416cb735c20f91f61ab8.png";